import { render, staticRenderFns } from "./SearchAcademy.vue?vue&type=template&id=626d9c35&scoped=true&lang=pug"
import script from "./SearchAcademy.vue?vue&type=script&lang=ts"
export * from "./SearchAcademy.vue?vue&type=script&lang=ts"
import style0 from "./SearchAcademy.vue?vue&type=style&index=0&id=626d9c35&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d9c35",
  null
  
)

export default component.exports